import React, { useEffect, useState } from "react";
import "./SessionTimeline.css";
import TimelineGraph from "./TimelineGraph";
import { useSelector } from "react-redux"; // optional external stylesheet

export const SessionTimeline = () => {
    const [timeline, setTimeline] = useState([]);
    const [totalTimeSec, setTotalTimeSec] = useState(0);
    const today = new Date().toISOString().split("T")[0];

    useEffect(() => {
        const stored = JSON.parse(localStorage.getItem(`sessionTimeline_${today}`)) || [];
        setTimeline(stored);

        // Calculate total time across sessions
        let total = 0;
        for (let i = 0; i < stored.length; i++) {
            if (stored[i].type === "start" && stored[i + 1]?.type === "stop") {
                total += (stored[i + 1].timestamp - stored[i].timestamp) / 1000;
            }
        }
        setTotalTimeSec(Math.floor(total));
    }, JSON.parse(localStorage.getItem(`sessionTimeline_${today}`)) || []);

    const sessionCount = timeline.filter(e => e.type === "start").length;
    const breakCount = timeline.filter(e => e.type === "stop").length;

    const handleExportLog = () => {
        let log = `Session Timeline for ${today}\n\n`;
        timeline.forEach((event, idx) => {
            const time = new Date(event.timestamp).toLocaleTimeString();
            log += `${idx + 1}. ${event.type === "start" ? "Started" : "Stopped"} at ${time}\n`;
        });
        log += `\nTotal time spent: ${totalTimeSec} seconds`;

        const blob = new Blob([log], { type: "text/plain" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `session_log_${today}.txt`;
        a.click();
        URL.revokeObjectURL(url);
    };
    // return <TimelineGraph timelineData={timeline}/>
    return (
        <>
            <div className="timeline-stats">

                <p><strong>Breaks:</strong> {breakCount}</p>
                <p><strong> Total 🕒:</strong> {totalTimeSec} seconds</p>
            </div>
            <div className="timeline-container">
                <ul className="timeline-list">
                    {timeline.map((event, idx) => (
                        <li
                            key={idx}
                            className={`timeline-item ${event.type === "start" ? "start" : "stop"}`}
                        >
                            <span className="event-icon">
                                {event.type === "start" ? "🟢" : "⛔"}
                            </span>
                            <span className="event-text">
                                {/*{event.type === "start" ? "Started" : "Stopped"} at{" "}*/}
                                {new Date(event.timestamp).toLocaleTimeString()}
                            </span>
                        </li>
                    ))}
                </ul>

                <button className="export-btn" onClick={handleExportLog}>
                    📤 Export Log as .txt
                </button>
            </div>
        </>
    );
};